import React, { useEffect, useState } from 'react';

import { filterMethod } from '../../Helpers/helpers';

import { Autocomplete, TextField } from '@mui/material';

const ConsumablesTypeAutoComplete = (props) => {
  const setByType = props.setByType;
  const consumablesType = props.consumablesType;
  // const selectedType = props.selectedType;
  // const constantTypeUpdate = props.constantTypeUpdate;
  const nameLabel = props.nameLabel;
  const size = props.size;

  const [selectedConsumable, setSelectedConsumable] = useState({});

  useEffect(() => {
    let Obj = findId(consumablesType, options);
    setSelectedConsumable(Obj);
  }, [consumablesType]);

  const handleChange = (event, newValue) => {
    setByType(newValue?.name);
    setSelectedConsumable(newValue);
  };

  return (
    <div>
      <Autocomplete
        sx={{
          width: '80%',
          background: '#ffffff',
          padding: 0,
        }}
        name='constantType'
        key='constantType'
        id='constantType'
        variant='standard'
        size={size}
        value={selectedConsumable}
        onChange={handleChange}
        disablePortal
        options={options}
        filterOptions={filterMethod}
        getOptionLabel={(option) => option.displayName}
        renderInput={(params) => <TextField {...params} label={nameLabel} />}
      />
    </div>
  );
};

export default ConsumablesTypeAutoComplete;

//Constants Type List
const options = [
  { id: '101', name: 'gas', displayName: '1. Gas' },
  { id: '102', name: 'spares', displayName: '2. Stock & Consumables' },
];

export const findId = (item, objectSet) => {
  let found = null;
  for (let i = 0; i < objectSet.length; i++) {
    if (objectSet[i].name === item) {
      found = objectSet[i];
      break;
    }
  }
  return found;
};
